import { render, staticRenderFns } from "./SmallChat.vue?vue&type=template&id=2c8bfe89&scoped=true&"
import script from "./SmallChat.vue?vue&type=script&lang=js&"
export * from "./SmallChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8bfe89",
  null
  
)

export default component.exports